export function categoryLabel(settings, category, fallback = "") {
  const list = settings?.facility_categories || [];
  const found = list.find((c) => c.key === category);
  return found?.label || fallback;
}

export function enabledCategories(settings) {
  return (settings?.facility_categories || []).filter((c) => c.enabled !== false);
}
